Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../../styles");
var _sharedStyles = require("../sharedStyles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp;
  var _useSharedStyles = (0, _sharedStyles.useSharedStyles)(),
    imageWidth = _useSharedStyles.imageWidth;
  var _imageHeightRatio = 548.22 / 675.02;
  var container = {
    position: 'relative',
    marginBottom: spacing.l,
    minWidth: imageWidth,
    minHeight: imageWidth * _imageHeightRatio
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    container.marginBottom = spacing.xl;
  }
  var background = {
    position: 'absolute',
    zIndex: 0,
    top: 0,
    left: 0,
    width: imageWidth,
    height: imageWidth * _imageHeightRatio
  };
  var children = {
    position: 'relative',
    zIndex: 1
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    background: background,
    children: children
  });
  return {
    styles: styles
  };
};